// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bar {
  margin-top: 8px;
}

.bar_one {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.country-box {
  height: 217px !important;
  margin-top: 30px;
}

.country-box .bar {
  margin: 8px 0;
}

.c-name {
  color: #FFFFFF;
}

.c-name span {
  font-size: 15px;
}

.new {
  margin-left: 8px;
  width: 37px;
}

.level {
  width: 100%;
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/StatePopup/index.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;AACJ;;AAEA;EACI,wBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,gBAAA;EACA,WAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;AACJ","sourcesContent":[".bar {\n    margin-top: 8px;\n}\n\n.bar_one {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n}\n\n.country-box {\n    height: 217px !important;\n    margin-top: 30px;\n}\n\n.country-box .bar {\n    margin: 8px 0;\n}\n\n.c-name {\n    color: #FFFFFF;\n}\n\n.c-name span {\n    font-size: 15px;\n}\n\n.new {\n    margin-left: 8px;\n    width: 37px;\n}\n\n.level {\n    width: 100%;\n    display: flex;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
